var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5709 3.19287C12.3 2.34788 12.7914 1.17098 12.6569 0C11.6063 0.04 10.3352 0.671147 9.58186 1.51514C8.90537 2.26413 8.31484 3.4609 8.47359 4.60889C9.64557 4.69588 10.8418 4.03885 11.5709 3.19287ZM14.199 10.625C14.2283 13.652 16.9697 14.6589 17 14.6719C16.9778 14.7429 16.5622 16.1066 15.556 17.5166C14.6854 18.7346 13.7824 19.9476 12.3596 19.9736C10.9621 19.9986 10.5122 19.1797 8.91346 19.1797C7.31577 19.1797 6.81624 19.9475 5.4936 19.9985C4.12039 20.0475 3.0738 18.6808 2.1971 17.4668C0.403235 14.9838 -0.966935 10.4501 0.873443 7.39014C1.78756 5.87116 3.42064 4.90779 5.19428 4.88379C6.54221 4.85879 7.81531 5.75293 8.63943 5.75293C9.46356 5.75293 11.0107 4.67794 12.6367 4.83594C13.3172 4.86294 15.2284 5.09885 16.455 6.81982C16.3559 6.87882 14.1747 8.09504 14.199 10.625Z",
    fill: "#6A7EB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIos);
export default __webpack_public_path__ + "static/media/platform_ios.a5b04e255191ea83b6b7a710e8cbbc63.svg";
export { ForwardRef as ReactComponent };